import { render } from "./SingleAward.vue?vue&type=template&id=ae4b2d34"
import script from "./SingleAward.vue?vue&type=script&lang=js"
export * from "./SingleAward.vue?vue&type=script&lang=js"

import "./SingleAward.vue?vue&type=style&index=0&id=ae4b2d34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__